import React, { useState, useEffect } from "react";
import "./styles.css";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepButton from "@mui/material/StepButton";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Organization from "./component/Organization";
import Address from "./component/Address";
import Contact from "./component/Contact";
import { createJSON } from "./data/createJSON";
import instance from "../../../order_managment/common/api/interceptor";
import { path } from "../../../order_managment/constants/apiPath";
import { NotificationManager } from "react-notifications";

const steps = [
  "Organization Information",
  "Add Address",
  "Contact Information",
];

function CreateUser() {
  const [activeStep, setActiveStep] = React.useState(0);
  const [completed, setCompleted] = React.useState({});
  const [createUser, setCreateUser] = useState({});
  const [errormsg, setErrormsg] = useState([]);

  const checkfields = () => {
    const temp = [];
    if (createUser?.OrgInfo?.OrgCode === "") {
      temp.push({
        fieldName: "Organization Code",
        error: "Please enter organization code",
      });
    }

    if (createUser?.OrgInfo?.MapppedOrgCode === "") {
      temp.push({
        fieldName: "Mapped Organization Code",
        error: "Please enter CW1 mapped organization code",
      });
    }

    if (createUser?.OrgInfo?.OrgName === "") {
      temp.push({
        fieldName: "Organiation Name",
        error: "Please enter organization name",
      });
    }

    if (createUser?.OrgInfo?.MapppedOrgName === "") {
      temp.push({
        fieldName: "Mapped organiation Name",
        error: "Please enter CW1 mapped organization name",
      });
    }

    if (
      !createUser?.OrgInfo?.IsConsignee ||
      !createUser?.OrgInfo?.IsConsignor ||
      !createUser?.OrgInfo?.IsForwarder
    ) {
      temp.push({
        fieldName: "User Role",
        error: "Please select user roles",
      });
    }
    setErrormsg(temp);
    if (
      createUser?.OrgInfo?.OrgCode &&
      createUser?.OrgInfo?.MapppedOrgCode &&
      createUser?.OrgInfo?.OrgName &&
      createUser?.OrgInfo?.MapppedOrgName &&
      (createUser?.OrgInfo?.IsConsignee ||
        createUser?.OrgInfo?.IsConsignor ||
        createUser?.OrgInfo?.IsForwarder)
    ) {
      handleNext();
    }
  };

  useEffect(() => {
    setCreateUser(JSON.parse(JSON.stringify(createJSON)));
  }, []);

  console.log(createUser);

  const totalSteps = () => {
    return steps.length;
  };

  const completedSteps = () => {
    return Object.keys(completed).length;
  };

  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  const allStepsCompleted = () => {
    return completedSteps() - 1 === totalSteps() - 1;
  };

  const onChange = (value, key, type) => {
    console.log(`${value},${key},${type}`);
    if (type === "Org") {
      const obj = { ...createUser.OrgInfo };
      obj[key] = value;
      setCreateUser({ ...createUser, OrgInfo: obj });
    } else if (type === "Addr") {
      const obj = [...createUser.Addresses];
      obj[0][key] = value;
      setCreateUser({ ...createUser, Addresses: [...obj] });
    } else if (type === "Cont") {
      const obj = [...createUser.Contacts];
      obj[0][key] = value;
      setCreateUser({ ...createUser, Contacts: [...obj] });
    } else if (type === "Buy") {
      const obj = [...createUser.BuyerCollection];
      obj[0][key] = value;
      setCreateUser({ ...createUser, BuyerCollection: [...obj] });
    } else if (type === "Sup") {
      const obj = [...createUser.SupplierCollection];
      obj[0][key] = value;
      setCreateUser({ ...createUser, SupplierCollection: [...obj] });
    }
    console.log(createUser);
  };

  const onRoleChange = (value, key, type) => {
    const obj = { ...createUser.OrgInfo };

    if (key === "IsForwarder") {
      obj[key] = obj[key] ? "0" : "1";
      obj["IsConsignor"] = "";
      obj["IsConsignee"] = "";
    } else if (key === "IsConsignor") {
      obj[key] = obj[key] ? "0" : "1";
      obj["IsForwarder"] = "";
      obj["IsConsignee"] = "";
    } else {
      obj[key] = obj[key] ? "0" : "1";
      obj["IsForwarder"] = "";
      obj["IsConsignor"] = "";
    }

    console.log({ obj });
    setCreateUser({ ...createUser, OrgInfo: obj });
  };

  const handleComplete = () => {
    const newCompleted = completed;
    newCompleted[activeStep] = true;
    setCompleted(newCompleted);
    checkfields();
  };
  const handleNext = () => {
    const steps = activeStep + 1;
    setActiveStep(steps);

    if (activeStep === 2) {
      postOrganization();
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStep = (step) => () => {
    setActiveStep(step);
  };

  const handleReset = () => {
    setActiveStep(0);
    setCompleted({});
  };

  const postOrganization = () => {
    const body = { ...createUser };

    // if(body.OrgInfo.IsConsignee)
    instance
      .post(path.POST_ORGANIZATION_USER, body)
      .then((res) => {
        if (res.Is_Success) {
          NotificationManager.success(res.Message, "", 3000);
          console.log(res);
        } else {
          NotificationManager.error(res.Message, "", 3000);
        }
      })
      .catch((err) => {
        console.log(err);
        if (err.response) {
          NotificationManager.error(err.response.data.Message, "", 3000);
        } else if (err.request) {
        } else if (err.message) {
        } else {
          NotificationManager.error("Something went wrong!", "", 3000);
        }
      });
  };

  return (
    <div className="_createRoot">
      <h3>Create Users</h3>
      <Stepper nonLinear activeStep={activeStep}>
        {steps.map((label, index) => (
          <Step key={label} completed={completed[index]}>
            <StepButton color="inherit" onClick={handleStep(index)}>
              {label}
            </StepButton>
          </Step>
        ))}
      </Stepper>
      <div className="_createOrgContainer">
        {activeStep === 3 ? (
          <>
            <Typography sx={{ mt: 2, mb: 1 }}>
              User Created Successfully
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
              <Box sx={{ flex: "1 1 auto" }} />
              <Button onClick={handleReset}>Reset</Button>
            </Box>
          </>
        ) : (
          <>
            <Typography>
              {activeStep === 0 ? (
                <Organization
                  organizationJSON={createUser?.OrgInfo}
                  errorMessage={errormsg}
                  onChange={onChange}
                  onRoleChange={onRoleChange}
                  buyerCollection={createUser.BuyerCollection}
                  supplierCollection={createUser.SupplierCollection}
                />
              ) : activeStep === 1 ? (
                <Address
                  addressJSON={createUser?.Addresses}
                  onChange={onChange}
                />
              ) : (
                <Contact
                  contactJSON={createUser?.Contacts}
                  onChange={onChange}
                />
              )}
              {/* Step {activeStep + 1} */}
            </Typography>
          </>
        )}
      </div>
      <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
        <Button
          color="inherit"
          disabled={activeStep === 0}
          onClick={handleBack}
          sx={{ mr: 1 }}
        >
          Back
        </Button>
        <Box sx={{ flex: "1 1 auto" }} />
        <Button disabled={activeStep >= 3} onClick={() => handleComplete()}>
          {activeStep >= 2 ? "Create User" : "Next"}
        </Button>
      </Box>
    </div>
  );
}

export default CreateUser;
